import { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { SeperateTagsDropdown } from 'basic-components';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_ARRAY = [];
const Email = ({
  value,
  onChange,
  size = undefined,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        [emailQuery, setEmailQuery] = useState(),
        queryClient = useQueryClient(),
        { fetchNextPage: fetchMoreEmails, isFetching: isFetchingEmails, isFetchingNextPage: isFetchingNextPageEmails, data: emails } = DropdownService.useQueryEmails({
          queryClient,
          input: emailQuery,
          getApiConfig: getApiConfigLocal
        }),
        multiselectDefaultValue = useMemo(() => value !== "" ? String(value).split(',').map(v => ({ label: v, value: v })) : EMPTY_ARRAY, [value])

  return (
    <SeperateTagsDropdown
        {...props}
        creatable
        defaultValue={multiselectDefaultValue}
        fetchNextPage={fetchMoreEmails}
        isFetching={isFetchingEmails || isFetchingNextPageEmails}
        multi
        onChange={onChange}
        onInputChange={setEmailQuery}
        options={emails}
        placeholder="Select or type email"
        ref={ref}
        size={size}
    />
  )
}

Email.displayName = "Email"

Email.propTypes = {
  onChange: PropTypes.func.isRequired, 
  size: PropTypes.string,
  value: PropTypes.any.isRequired,
}

export default memo(Email);